import React, { useEffect, useState } from 'react'
import { InputField, SelectField } from 'cwp-components/forms'
import SocialMediaLinks from 'cwp-components/SocialMediaLinks/SocialMediaLinks'
import { useForm } from 'react-hook-form'
import { AiOutlineSearch } from 'react-icons/ai'
import { SORT_OPTIONS, SortOption } from 'common/hooks/useArticleTemplate'

const DiscoverLawFilterSection = ({
  setSortOption,
  sortOption,
  setMostViewedSelected,
  mostViewedSelected,
}: {
  setSortOption: (sort: SortOption) => void
  sortOption: SortOption
  setMostViewedSelected: (selected: boolean) => void
  mostViewedSelected: boolean
}) => {
  const {
    register,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })
  const [filterApplied, setFilterApplied] = useState<boolean>(false)
  const [resetKey, setResetKey] = useState<number>(0)

  const clearFilters = () => {
    setFilterApplied(false)
    setResetKey(resetKey + 1)
    handleDropDownSelect(SORT_OPTIONS[2].label)
  }

  const handleDropDownSelect = (label) => {
    if (label == 'Most viewed') {
      setMostViewedSelected(true)
    } else {
      setMostViewedSelected(false)
      setSortOption(SORT_OPTIONS.find((filter) => filter.label === label))
    }
  }

  useEffect(() => {
    setFilterApplied(sortOption != SORT_OPTIONS[2] || mostViewedSelected)
  }, [sortOption, mostViewedSelected])

  return (
    <div className='py-6 p-10 lg:p-[80px]'>
      <div
        className='flex flex-col md:flex-row items-center gap-6
'
      >
        <SocialMediaLinks className='md:w-4/12' />
        <div className='w-full  md:w-8/12'>
          <div className='flex flex-col md:flex-row gap-3 md:gap-6'>
            <div className='w-full md:w-5/12'>
              <InputField
                register={register}
                required={false}
                icon={<AiOutlineSearch />}
                id='search'
                label='Search'
                placeholder='Type what you are searching for...'
                errors={errors}
                errorMessage=''
              />
            </div>
            <div className='md:w-7/12 flex flex-col md:flex-row gap-3 md:gap-6'>
              <div className='w-full md:w-8/12'>
                <SelectField
                  key={`SelectField_${resetKey}`}
                  register={register}
                  required={false}
                  id='filterBy'
                  records={[
                    ...SORT_OPTIONS,
                    { label: 'Most viewed', value: 'most_viewed' },
                  ]}
                  onSelectionChange={handleDropDownSelect}
                  label={sortOption.label}
                  placeholder='Filter By'
                  selectClassName='!h-[40px]'
                />
              </div>
              <div className='md:w-4/12 flex items-center justify-center'>
                <button
                  onClick={clearFilters}
                  disabled={!filterApplied}
                  className={`text-xs lg:text-base font-medium text-[#00323D] disabled:text-[#A0ABBE] disabled:cursor-not-allowed`}
                >
                  Clear filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiscoverLawFilterSection
